import { ECountry } from 'common/const';
import { getAppSettings } from 'common/settings';

/* Адреса документов по стране (US-019, payment-page-localization.md; pay-host R-3).
 *  Все документы обеих стран - страницы сайта hvala-frontend: хост из настройки сборки REACT_APP_SITE_URL,
 *  слаги RS без суффикса, ME - с суффиксом _me (та же конвенция у мобилки). */
const documentUrl = (country: ECountry, slug: string) => {
  const countrySlug = country === ECountry.ME ? `${slug}_me` : slug;

  return `${getAppSettings().siteUrl}/${countrySlug}`;
};

export interface ITipsDocumentUrls {
  usloviKoriscenja: string;
  ugovorOPoklonu: string;
  politikaPrivatnosti: string;
  kolacici: string;
  odustanakOdPoklona: string;
}

/* Пять документов в согласии перед оплатой. */
export const getTipsDocumentUrls = (country: ECountry): ITipsDocumentUrls => ({
  usloviKoriscenja: documentUrl(country, 'uslovi_koriscenja'),
  ugovorOPoklonu: documentUrl(country, 'ugovor_o_poklonu'),
  politikaPrivatnosti: documentUrl(country, 'politika_privatnosti'),
  kolacici: documentUrl(country, 'kolacici'),
  odustanakOdPoklona: documentUrl(country, 'odustanak_od_poklona'),
});

/* Политика приватности в согласии формы жалобы: у RS английская privacy_policy, как до переезда. */
export const getComplainPrivacyPolicyUrl = (country: ECountry): string =>
  documentUrl(country, country === ECountry.ME ? 'politika_privatnosti' : 'privacy_policy');

/* Ссылка на кукис в cookie-попапе. */
export const getCookiePolicyUrl = (country: ECountry): string => documentUrl(country, 'kolacici');
